import { useState } from "react";

const FORM_ADDR = "https://readdy.ai/api/form/daf7ta9tto0ceqqnh7eg";

interface FormStatus {
  kind: "idle" | "loading" | "success" | "error";
  message?: string;
}

export default function Subscribe() {
  const [status, setStatus] = useState<FormStatus>({ kind: "idle" });

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // honeypot 命中时静默返回成功，不提交
    const honeypot = String(fd.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus({ kind: "success", message: "订阅成功，甜瓜即将送达你的邮箱～" });
      form.reset();
      return;
    }

    const email = String(fd.get("email") ?? "").trim();
    if (!email) {
      setStatus({ kind: "error", message: "请填写你的邮箱地址。" });
      return;
    }

    setStatus({ kind: "loading" });
    const payload = new URLSearchParams();
    for (const [key, value] of fd.entries()) {
      if (key === "website_alt") continue;
      if (typeof value === "string") payload.append(key, value);
    }

    try {
      const response = await fetch(FORM_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = (parsed?.meta ?? {}) as Record<string, unknown>;
      const serverMsg =
        String(meta?.message ?? "") || String(parsed?.message ?? "") || String(meta?.detail ?? "");
      const code = String(parsed?.code ?? "");

      if (response.ok && code === "OK") {
        setStatus({ kind: "success", message: "订阅成功，甜瓜即将送达你的邮箱～" });
        form.reset();
      } else {
        const lower = (responseText + serverMsg).toLowerCase();
        const failMsg = lower.includes("spam")
          ? "提交未成功，请稍后重试。"
          : serverMsg || "提交失败，请稍后再试。";
        setStatus({ kind: "error", message: failMsg });
      }
    } catch {
      setStatus({ kind: "error", message: "网络异常，请稍后再试。" });
    }
  }

  return (
    <section id="subscribe" className="scroll-mt-24 relative overflow-hidden bg-primary-600">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=close%20up%20of%20fresh%20watermelon%20slices%20with%20vivid%20green%20rind%20and%20juicy%20red%20flesh%20on%20warm%20textured%20background%2C%20soft%20natural%20light%2C%20appetizing%20summer%20food%20photography&width=1800&height=700&seq=gua-sub-01&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-primary-700/80"></div>

      <div className="relative mx-auto max-w-3xl px-4 py-16 text-center md:px-6 md:py-20">
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50">
          <i className="ri-mail-send-line"></i>
          免费订阅
        </span>
        <h2 className="mt-4 font-heading text-2xl font-black text-background-50 md:text-4xl">
          每天 18:00，把今日精选瓜送到你手里
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
          订阅「吃瓜大全」精选合集，第一时间收到今日热榜、高赞精华帖与主编特别推荐，不再错过好内容。
        </p>

        <form
          id="daily-gua-newsletter"
          data-readdy-form
          onSubmit={handleSubmit}
          className="mx-auto mt-8 flex max-w-xl flex-col gap-3 sm:flex-row"
          noValidate
        >
          <label className="sr-only" htmlFor="gua-email">
            邮箱地址
          </label>
          <input
            id="gua-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="请输入你的邮箱地址"
            className="w-full rounded-full border border-background-50/30 bg-background-50/95 px-5 py-3 text-sm text-foreground-950 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-background-50/70"
          />
          <input
            name="website_alt"
            type="text"
            aria-hidden="true"
            readOnly
            tabIndex={-1}
            autoComplete="off"
            className="honeypot-guard"
          />
          <button
            type="submit"
            disabled={status.kind === "loading"}
            className="whitespace-nowrap rounded-full bg-background-50 px-7 py-3 text-sm font-semibold text-primary-700 hover:bg-background-100 disabled:opacity-60 transition-colors"
          >
            {status.kind === "loading" ? "提交中…" : "立即订阅"}
          </button>
        </form>

        {status.kind === "success" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-secondary-500 px-4 py-2 text-sm text-background-50">
            <i className="ri-check-line"></i>
            {status.message}
          </p>
        )}
        {status.kind === "error" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-background-950/90 px-4 py-2 text-sm text-background-50">
            <i className="ri-error-warning-line"></i>
            {status.message}
          </p>
        )}

        <p className="mt-4 text-xs text-background-100/70">订阅后可随时取消，我们只发精选，绝不打扰。</p>
      </div>
    </section>
  );
}